// TextblockSendScope — spiegelt das Backend-Enum (AveOrga.Domain.Enums.TextblockSendScope).
// Enums kommen als String über die API (JsonStringEnumConverter), ältere Daten evtl. als Zahl.
export const SEND_SCOPE = {
  EventBound: 'EventBound',     // nur mit Spieltag
  PlayerDirect: 'PlayerDirect', // nur direkt an Spieler (ohne Spieltag)
  Both: 'Both',                 // mit & ohne Spieltag
  Automatic: 'Automatic',       // nie manuell (System-intern)
};

const NUM_TO_SCOPE = ['EventBound', 'PlayerDirect', 'Both', 'Automatic'];

export function normalizeScope(value) {
  if (typeof value === 'number') return NUM_TO_SCOPE[value] ?? SEND_SCOPE.Both;
  return value ?? SEND_SCOPE.Both;
}

export const SCOPE_LABELS = {
  EventBound: 'Nur mit Spieltag',
  PlayerDirect: 'Nur ohne Spieltag',
  Both: 'Mit & ohne Spieltag',
  Automatic: 'Automatisch (nicht manuell sendbar)',
};

// Textbausteine, die im jeweiligen Mailmodus im Dropdown auswählbar sind.
export function isSelectableInEventMode(scope) {
  const s = normalizeScope(scope);
  return s === SEND_SCOPE.EventBound || s === SEND_SCOPE.Both;
}

export function isSelectableInPlayerMode(scope) {
  const s = normalizeScope(scope);
  return s === SEND_SCOPE.PlayerDirect || s === SEND_SCOPE.Both;
}

// Im Editor klassifizierbare Scopes. "Automatisch" = nur für automatische Mails (Mail-Regeln, Schritte),
// taucht im manuellen Versand nicht auf.
export const EDITABLE_SCOPES = [SEND_SCOPE.EventBound, SEND_SCOPE.PlayerDirect, SEND_SCOPE.Both, SEND_SCOPE.Automatic];
